export const STATUS_LIST_VALUE_LABEL = [
    {
      value: null,
      label: 'Todos',
    },
    {
      value: true,
      label: 'Ativo',
    },
    {
      value: false,
      label: 'Inativo',
    },
  ];